/**
 * Aspect — client MeltFlex Photo-to-Render
 * --------------------------------------------------------------
 * Sends a Revive still to the orchestrator. The MeltFlex key never ships
 * in the browser bundle.
 */

import { orchUrl } from "./endpoints.js";
import { compressImageDataUrl } from "./image_compress.js";

export async function requestReviveRender(imageDataUrl, { hour } = {}) {
  const image = await compressImageDataUrl(imageDataUrl, 1400, 0.84);
  const res = await fetch(`${orchUrl()}/revive-render`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      image,
      hour: Number.isFinite(hour) ? hour : undefined,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.image) {
    throw new Error(data.error || `Render failed (${res.status})`);
  }
  return data.image;
}
